import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import { SAMPLES_VALIDATING_UPDATED } from 'redux/actionTypes/samples';
import SampleValidationError from 'utils/errors/upload/SampleValidationError';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import sampleValidators from 'utils/upload/sampleValidators';
import config from 'config';
var handleValidatorError = function handleValidatorError(e, sampleName) {
  if (e instanceof SampleValidationError) {
    var _errorMessage = "Error uploading sample ".concat(sampleName, ".\n").concat(e.message);
    pushNotificationMessage('error', _errorMessage, 15);
  } else {
    var _errorMessage2 = "Error uploading sample ".concat(sampleName, ". Please send an email to ").concat(config.supportEmail, " with the sample files you're trying to upload.");
    pushNotificationMessage('error', _errorMessage2);
    console.error(e.message);
  }
};
var validateSamples = function validateSamples(experimentId, samplesMap, technology) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var samplesList, results, validSamplesList;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              samplesList = Object.entries(samplesMap);
              dispatch({
                type: SAMPLES_VALIDATING_UPDATED,
                payload: {
                  experimentId: experimentId,
                  validating: true
                }
              });
              _context2.next = 4;
              return Promise.allSettled(samplesList.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
                  var _ref4, sampleName, sample;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _ref4 = _slicedToArray(_ref2, 2), sampleName = _ref4[0], sample = _ref4[1];
                          _context.prev = 1;
                          _context.next = 4;
                          return sampleValidators[technology](sample);
                        case 4:
                          return _context.abrupt("return", [sampleName, sample]);
                        case 7:
                          _context.prev = 7;
                          _context.t0 = _context["catch"](1);
                          handleValidatorError(_context.t0, sampleName);
                          throw _context.t0;
                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[1, 7]]);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 4:
              results = _context2.sent;
              dispatch({
                type: SAMPLES_VALIDATING_UPDATED,
                payload: {
                  experimentId: experimentId,
                  validating: false
                }
              });
              validSamplesList = results.filter(function (result) {
                return result.status === 'fulfilled';
              }).map(function (result) {
                return result.value;
              });
              return _context2.abrupt("return", validSamplesList);
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default validateSamples;